import { useQuery } from '@tanstack/react-query'
import { fetchWrapper } from '~/utils/fetchWrapper'
import { TaskObject } from '~/types/TaskType'
import { Message } from '~/components/chat/message'

export interface SuperAdminTaskDetails {
  task: TaskObject
  messages: Message[]
}

const fetchSuperAdminTaskDetails = async (taskId: number): Promise<SuperAdminTaskDetails> => {
  // Fetch task details directly via super admin endpoint (bypasses conversation permissions)
  const response = await fetchWrapper(`/api/super-admin/tasks/taskdetails?taskid=${taskId}`, {
    method: 'GET',
    suppressErrorToast: true
  })

  if (!response.ok) {
    const reason = await response.text()
    throw new Error(`Failed to fetch task details: ${reason}`)
  }

  return response.json()
}

export const useSuperAdminTaskDetails = (taskId: number) => {
  return useQuery({
    queryKey: ['superAdminTaskDetails', taskId],
    queryFn: () => fetchSuperAdminTaskDetails(taskId),
    enabled: !!taskId
  })
}
